module.exports = __webpack_public_path__ + "img/Modal Nasional.6f91ef87.png";